import React,{useEffect,useState} from 'react';
import {Doughnut, } from 'react-chartjs-2';
import {Card,Box, Typography, } from "@material-ui/core";

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  contenedorCard:{
    //paddingRight:'3rem'
    height:10+'rem'//,marginRight:".2rem"
  },
  card:{
    boxShadow:'0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)',
    //color:'#4a4a4a',
  },
  tituloGraf:{
    paddingTop:'0rem',
    textAlign:'center'
  },
  nested: {
    paddingLeft: theme.spacing(2),
  },
}));

export default function GraficaPolar({valor}){
  const classes = useStyles();
  const auxColor=process.env.REACT_APP_Fondo_Color
  const [data,setData]= useState([]);
  const [dataTpTarea,setDataTpTarea]= useState([]);
 


  const [bandera,setBandera]= useState(false);
  useEffect(()=>{    
    
    if (valor.SolicitudTipo.legnth !== 0 ) {
      let etiq =[], arr=[]
      valor.SolicitudTipo.forEach(element => {
        etiq.push(element.Nom)
        arr.push(element.Total)
      });
      setData({ 
        labels:etiq, 
        datasets:[{ 
          label:"Tipo Solicitud ",
          data:arr, 
          backgroundColor:["#58b85c","#4295f5"],
        //  borderColor: colores,
        }]
      })
    }
    
      if (valor.TareaTipo.legnth !== 0 ) {
      let etiq =[], arr=[]  
      valor.TareaTipo.forEach(element => {
        etiq.push(element.Nom)
        arr.push(element.Total)
      });
      setDataTpTarea({ 
        labels:etiq, 
        datasets:[{ 
          label:"Tipo Tarea",
          data:arr, 
          backgroundColor:["#58b85c","#4295f5","#e91e63"],
        //  borderColor: colores,
        }]
      })
    }

    setBandera(true) 
  },[valor])


  const options = {
  
  //  indexAxis:'y',
    tooltips: {
      enabled: true,
    },
   /*  layout: {
      padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
      }
    }, */
    title:{
      fontStyle: 'bold',
    },
   /*  scales: {
      x: {
          display: true,
          title: {
          display: true
          }
      },
      y: {
          display: true,
          title: {
          display: false,
       
          },
       
      },
      } */
   /*  scales: {
      x: {
        stacked: true,
        ticks: {
          beginAtZero: true,
        },
      },
      y: {
        stacked: true,
        labe :{
          fontSize:6,
        },
      }
    
    }, */
  } 

  function  llenadoTabla2(datos, nombre )
  {
    return(
    <Card className={classes.card} style={{paddingRight:.8+'rem',paddingLeft:.8+'rem' 
      ,paddingBottom:.5+'rem',height:25.5+'rem',width:25+'rem'}} >              
      <Doughnut
        id="graficaMuni1"
        data={datos}
        width={400} height={200} 
        options={options}
      />   
      <Typography>{nombre}</Typography>
    </Card>
    );
  }

  return (
  <Box display="flex" flexDirection="row" justifyContent={'center'} mb={1}  >           
    <Box display="flex"className={classes.contenedorCard}  >
      {data.length!==0 ?llenadoTabla2(data, "Tipo Solicitud" ):null}
    </Box>    
    <Box display="flex"className={classes.contenedorCard} ml={1}  >
      {dataTpTarea.length!==0 ?llenadoTabla2(dataTpTarea, "Materia" ):null}
    </Box> 
  </Box>
  );
}